import React, { FunctionComponent } from 'react';
import {
  Tooltip,
  TooltipProps,
  TooltipInitialState,
  useTooltipState,
  TooltipReference,
} from 'reakit/Tooltip';
import cx from 'classnames';
import { motion, AnimatePresence, Transition } from 'framer-motion';

import { Enum } from '../../common/types';

export const CKNavTooltipVariant = Enum('default', 'x');
export type CKNavTooltipVariant = Enum<typeof CKNavTooltipVariant>;

export interface CKNavTooltipProps extends TooltipProps {
  variant?: CKNavTooltipVariant;
  transition?: Transition;
  tooltip: React.ReactNode;
  options?: TooltipInitialState;
  children: React.ReactElement;
}

export const CKNavTooltip: FunctionComponent<CKNavTooltipProps> = ({
  children,
  variant = CKNavTooltipVariant.default,
  transition = { ease: 'circOut', duration: 0.2 },
  tooltip,
  options,
}) => {
  const tooltipState = useTooltipState(options);
  const tooltipClass = cx({
    'ck-nav-tooltip': variant === CKNavTooltipVariant.default,
    'ck-nav-tooltip x': variant === CKNavTooltipVariant.x,
  });

  return (
    <React.Fragment>
      <TooltipReference
        {...tooltipState}
        // @ts-ignore
        ref={children.ref}
        {...children.props}
      >
        {referenceProps => React.cloneElement(children, referenceProps)}
      </TooltipReference>
      <Tooltip {...tooltipState}>
        {props =>
          tooltipState.visible && (
            <div {...props}>
              <AnimatePresence>
                <motion.div
                  transition={transition}
                  className={tooltipClass}
                  initial={{ opacity: 0, x: 0 }}
                  animate={{ opacity: 1, x: 5 }}
                  exit={{ opacity: 0, x: 0 }}
                >
                  {tooltip}
                </motion.div>
              </AnimatePresence>
            </div>
          )
        }
      </Tooltip>
    </React.Fragment>
  );
};
